import React from "react";

import { BrokerFormFooter } from "Features/BrokerForm";
import { Helmet } from "react-helmet";

import { usePartnerContext } from "Common/PartnerContext";
import ThemeInstaller from "Common/ThemeInstaller";
import ResponsiveTopBar from "Common/TopBar/ResponsiveTopBar";

type Props = {
  title?: string;
  children?: React.ReactNode;
};

const NavBar = () => {
  const { partner } = usePartnerContext();

  return <ResponsiveTopBar branding={partner} collapseOnSelect={false} />;
};

const Chrome = ({ children, title }: Props) => (
  <>
    <Helmet title={title} defaultTitle="SimplyInsured" />
    <NavBar />
    {children}
    <BrokerFormFooter showSISupportLinks />
    <ThemeInstaller />
  </>
);

export default Chrome;
